import React from 'react';
import { handleChange } from 'lib/stores/formStore';
import GenerateButton from 'lib/components/GenerateButton';
import ValidationStore from 'lib/stores/validationStore';

const RoomGenerate = () => {
  const generate = () => {
    ValidationStore.update(state => {
      state.room.bathroom_type = true;
      state.room.bed_type = true;
      state.room.name = true;
    });

    handleChange('Test Room', 'room.name');
    handleChange('Own', 'room.bathroom_type');
    handleChange('Single', 'room.bed_type');
  };

  return (
    <GenerateButton generate={generate} />
  );
};

export default RoomGenerate;
